import { httpClient } from './client';

export type ShipmentUsageDetailsResponse = {
  shipmentCount: number;
  baseShipmentCount: number;
  fulfillmentCount: number;
  purchasedShipmentCount: number;
  purchasedShipmentPrice: number; // this is in the seller's subscription currency
  totalUsage: number;
  shipmentLimit: number;
  remainingShipments: number;
  isUnlimitedShipments: boolean;
  isInTrial: boolean;
  shipmentPeriodStart: string | null;
  shipmentPeriodEnd: string | null;
  daysElapsed: number;
  daysLeft: number;
};

/**
 * Fetch shipment usage details for the current shipment period (distinct from the billing period).
 */
export const getShipmentUsageDetails = async (): Promise<ShipmentUsageDetailsResponse> => {
  const response = await httpClient.get('/account/shipmentUsage');
  return response.data;
};
